import { type FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";
import { useAttorneyHelplineEnabled } from "@/shared/hooks/useAttorneyHelplineEnabled";

import { AttorneyCta } from "./AttorneyCta";

export const ExecutorAllDeclineScreen: FC<FlowCustomComponentProps> = () => {
  const helplineEnabled = useAttorneyHelplineEnabled();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-1">
        <p className="font-sans text-xl font-semibold leading-[30px]">
          This estate requires a different court petition
        </p>
        <p className="text-sm text-secondary tracking-[-0.28px]">
          Because no executor named in the will can serve, standard probate forms cannot be used.
          This situation requires a "Petition for Letters of Administration c.t.a." (with will
          annexed).
        </p>
      </div>

      <div className="flex flex-col rounded-lg border border-primary overflow-clip">
        <div className={`flex flex-col gap-2 bg-white p-6${helplineEnabled ? " border-b border-primary" : ""}`}>
          <p className="text-sm font-semibold">What this means</p>
          <p className="text-sm text-secondary tracking-[-0.28px]">
            The court will appoint an administrator to carry out the will's instructions instead of
            a named executor. This requires a separate legal filing.
          </p>
        </div>
        {helplineEnabled && (
          <div className="flex flex-col gap-2 bg-white p-6">
            <p className="text-sm font-semibold">What to do next</p>
            <p className="text-sm text-secondary tracking-[-0.28px]">
              Please contact our Attorney Helpline so we can connect you with an attorney to help file
              the correct application.
            </p>
          </div>
        )}
      </div>

      <AttorneyCta
        title="Talk to an attorney"
        body="An attorney can guide you through the Administration c.t.a. process. This consultation is included in your plan."
      />
    </div>
  );
};
